<div class="tga-map-card">
  @if (mapDataResource(); as externalResource) {
    @if (isLoading(externalResource)) {
      <div class="loading-container">
        <app-loading-card [loadingText]="'BFP.UI.Loading'" />
      </div>
    } @else if (isError(externalResource)) {
      <mat-card class="error-card">
        <mat-card-content>
          <agr-notification-empty
            [isEmpty]="true"
            [emptyDescription]="
              'TGA.Advice.Soil.errors.failedToLoadMap' | translate: { mapTitle: (mapTitle() | translate) }
            "
            [showEmptyAction]="false"
            emptyActionColor="primary"
          />
        </mat-card-content>
      </mat-card>
    } @else if (isLoaded(externalResource)) {
      <div class="map-card-content">
        <!-- Render the actual map -->
        <h3 class="map-title">{{ mapTitle() | translate }}</h3>
        <div class="map-container">
          <img
            [src]="'data:' + externalResource.data.contentType + ';base64,' + externalResource.data.imageData"
            [alt]="mapTitle()"
            class="map-image"
          />
        </div>
        <div class="legend">
          @if (legendType() === 'gradient') {
            <div class="legend-gradient-container">
              <div
                class="legend-gradient"
                [style.background]="getGradientBackground(mapDataFromResponse(externalResource.data))"
              ></div>
              <div class="legend-gradient-labels">
                @for (entry of translatedDisplayLabels(); track entry.label) {
                  <span
                    class="legend-gradient-label"
                    [style.left.%]="getLabelPosition(entry, externalResource.data.legendData.entries)"
                    [title]="entry.label"
                  >
                    {{ entry.translatedLabel }}
                  </span>
                }
              </div>
            </div>
          } @else {
            @for (entry of translatedAllLabels(); track entry.label) {
              <div class="legend-item">
                <div class="legend-color" [style.background-color]="entry.color"></div>
                <span class="legend-label">{{ entry.translatedLabel }}</span>
              </div>
            }
          }
          @if (isImageWithDescription(externalResource.data) && externalResource.data.description.params) {
            <div class="legend-description">
              {{
                externalResource.data.description.translationKey | translate: externalResource.data.description.params
              }}
            </div>
          }
        </div>
      </div>
    }
  }
</div>
